import { useChatContext } from "duck/ui/chat/contexts/useChatContext";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useTranslation } from "react-i18next";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

import IconButton from "features/components/IconButton";

const LOGFIRE_URL_TEMPLATE =
  "https://logfire-us.pydantic.dev/viaduct-ai/python-ai-server?q=attributes->>'viaduct.thread_id'+%3D+'{THREAD_ID}'&last=\"30d\"";

const ThreadLogURL = () => {
  const { t } = useTranslation("duck");
  const { currentThreadId } = useChatContext();
  const { duckThreadLogButton } = useFlags();

  // Only render for users with FeatureFlag and with an active thread
  if (!duckThreadLogButton || !currentThreadId) {
    return null;
  }

  const getLogfireUrl = () => {
    if (!currentThreadId) return null;

    const encodedThreadId = encodeURIComponent(currentThreadId);

    return LOGFIRE_URL_TEMPLATE.replace("{THREAD_ID}", encodedThreadId);
  };

  const handleLogfireClick = () => {
    const url = getLogfireUrl();
    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <IconButton
      onClick={handleLogfireClick}
      color="secondary"
      size="small"
      data-testid="duck-logfire-link"
      tooltip={t("view_in_logfire")}
    >
      <OpenInNewIcon fontSize="small" />
    </IconButton>
  );
};

export default ThreadLogURL;
